import React from 'react';
import PropTypes from 'prop-types';
import './Heading.scss';

const Heading = ({ level = 2, children }) => {
  // 2. Assign the dynamic string to a Capitalized variable for JSX rendering
  const Tag = `h${level}`;

  return (
    <Tag className="edu-heading">
      {children}
    </Tag>
  );
};

Heading.propTypes = {
  children: PropTypes.node.isRequired,
  // 3. Ensuring level is one of the allowed heading numbers
  level: PropTypes.oneOf([1, 2, 3, 4, 5])
};

export default Heading;
